import { VoiceStatus } from "@next-platform/packages-ts-types";
import type { UserVoice } from "@next-platform/client-common-core";

export const shouldRedirectFromReclone = (recloneId: string | null, voice: UserVoice | null): boolean => {
  return Boolean(recloneId && voice && voice.id === recloneId && voice.status !== VoiceStatus.READY_FOR_PREVIEW);
};
